namespace SP {
    export interface RestockListInfo {
        id: number;
        time: string;
        user: string;
        finished: boolean;
        stockName: string;
        routeLength: number;
        lines: RestockListLineInfo[];
    }

    export interface RestockListLineInfo {
        id: string;
        fromToteId: number;
        fromPlacementId: number;
        toPlacementId: number;
        fromPlacementData: string;
        toPlacementData: string;
        moveLots: { [lotId: string]: number };
        finished: boolean;
    }
}